import React, { memo } from 'react';
import { SparklesIcon, Leaf, UsersIcon } from 'lucide-react';
const ValueCards = () => {
  return <section className="py-20 bg-white" data-id="element-933">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-934">
        <div className="text-center mb-16" data-id="element-935">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-936">
            Why luxury spas choose SmartSoda
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-937">
            The premium beverage solution transforming the spa guest experience
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-938">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-939">
            <div className="mb-6 bg-blue-50 p-4 rounded-full" data-id="element-940">
              <SparklesIcon className="h-8 w-8 text-blue-600" data-id="element-941" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-942">
              Luxury Guest Experience
            </h3>
            <p className="text-gray-600 text-center" data-id="element-943">
              Enhance your spa's ambiance with premium alkaline, vitamin-infused
              beverages that complement treatments and create memorable
              experiences.
            </p>
          </div>
          {/* Card 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-944">
            <div className="mb-6 bg-green-50 p-4 rounded-full" data-id="element-945">
              <Leaf className="h-8 w-8 text-green-600" data-id="element-946" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-947">
              Wellness-Focused
            </h3>
            <p className="text-gray-600 text-center" data-id="element-948">
              Offer clean-label, functional beverages that align with your
              wellness philosophy and enhance the holistic benefits of your spa
              treatments.
            </p>
          </div>
          {/* Card 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow flex flex-col items-center" data-id="element-949">
            <div className="mb-6 bg-amber-50 p-4 rounded-full" data-id="element-950">
              <UsersIcon className="h-8 w-8 text-amber-600" data-id="element-951" />
            </div>
            <h3 className="text-xl font-semibold text-navy-950 mb-4 text-center" data-id="element-952">
              Client Retention Booster
            </h3>
            <p className="text-gray-600 text-center" data-id="element-953">
              Increase guest satisfaction, reduce churn, and enhance lifetime
              value with memorable wellness experiences that keep clients
              returning.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-954">
          <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-955">
            Transform Your Spa Experience
          </a>
        </div>
      </div>
    </section>;
};
export default ValueCards;